import React from 'react';

import { IconTypes } from '@eika/icon';
import { IconLink } from '@eika/link';

import { useConfig } from '../../defaultConfig';
import useTranslation from '../../hooks/useTranslation';

const SalaryInfoHeader: React.FC = () => {
    const translated = useTranslation();
    const { editSalaryInfoStartPageLink } = useConfig();
    return (
        <div className="salary-info-header">
            <h2 className="typography-subtitle-bold">{translated.salaryInfo.title}</h2>
            {editSalaryInfoStartPageLink && (
                <IconLink
                    icon={IconTypes.PENN_24}
                    href={editSalaryInfoStartPageLink.url}
                    className="salary-info-header__icon"
                    data-testid="edit-salary-button"
                >
                    <span className="screen-reader-text">{translated.salaryInfo.editLink}</span>
                </IconLink>
            )}
        </div>
    );
};

export default SalaryInfoHeader;
